import React from 'react';
import { useQuery } from '@apollo/client';
import { readAllStatuses } from './api';

interface Props {
  formik: any;
}

const StatusDropdown = (props: Props) => {
  const { loading, error, data } = useQuery(readAllStatuses);

  if (loading) return null;
  if (error) return <div>error</div>;

  //TODO: dangerous, but works...<8 is all the non transfer items
  const statuses = data.readAllStatuses.filter((status, index) => index < 8);
  return (
    <div className='form-group form-inline'>
      <label className='col-sm-3'>Status</label>
      <select
        className='form-control col-sm-8'
        id='status'
        name='status'
        onChange={props.formik.handleChange}
        value={props.formik.values.status}
        defaultValue={1}>
        {statuses.map((status: any, index: number) => {
          return (
            <option key={index} value={status.statusName}>
              {status.statusName}
            </option>
          );
        })}
      </select>
    </div>
  );
};

export default StatusDropdown;
